// Auto-generated skeleton for ReportType

export const ReportType: Api.ReportType = {
  id: 0,
  name: '',
  description: '',
  is_system_type: false,
  report_sub_types: [],
};

